import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import { StyledContainer, StyledShadow } from './Background.styled';

const Background: React.FC = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleMoveDay} />
		)}
		<StyledContainer className={`${Layouts.VehiclePassport}-background`}>
			<StyledShadow />
		</StyledContainer>
	</Fragment>
);

export { Background };
